<div class="modal-header">
  <h4 class="modal-title">Medicare Card Example</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <p>
    <img src="assets/images/medicare_example.jpg" class="w-100" alt="Medicare Card Example">
  </p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-dark" (click)="activeModal.close('Close click')">Close</button>
</div>



// WEBPACK FOOTER //
// ./src/app/shared/components/fields/medicare-modal/medicare-modal.component.html